import Dropdown from "../../../components/dropdown/Dropdown.jsx";
import Code from "../../../components/code/Code.jsx";

<div className="box_link"><a className="link  link_materials" target="_blank" href="https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/materialy_dodatkowe/pokazowe/Informatyka/MINP-R0-100-2203.pdf">LINK DO ARKUSZA</a>
<br/>
<a className="link  link_materials" href="https://cke.gov.pl/images/_EGZAMIN_MATURALNY_OD_2023/materialy_dodatkowe/pokazowe/Informatyka/Dane_2203.zip" >PLIKI DO ZADANIA</a>
<br/>
</div>

### TREŚĆ

<b>Uwaga:</b> do rozwiązania zadań 1.1.–1.3. nie jest potrzebna znajomość reguł gry w szachy.<br/>
W pliku <i>szachy.txt</i> znajduje się zapis partii szachów, jaką w 2020 roku rozegrali polski
arcymistrz Jan Krzysztof Duda oraz mistrz świata Magnus Carlssen. Zapis partii składa się
z opisów 125 plansz przedstawiających stany gry (położenie bierek na szachownicy) po
kolejnych posunięciach każdego z graczy. Opis każdej planszy składa się z:<br/>
• 8 wierszy tekstu po 8 znaków w każdym wierszu<br/>
• kolejne znaki w wierszach oznaczają:<br/>
<pre>   − znak '.' − puste pole</pre>  
<pre>   − wielkie litery − białe bierki (czyli białe figury i pionki)</pre>  
<pre>   − małe litery − czarne bierki</pre>  
<pre>   − oznaczenia bierek to:</pre> 
<pre>        − K/k − król, </pre> 
<pre>        − H/h − hetman,</pre> 
<pre>        − W/w − wieża,</pre> 
<pre>        − G/g − goniec,</pre> 
<pre>        − S/s − skoczek, </pre> 
<pre>        − P/p − pionek.</pre> 
<br/>
Dla zachowania czytelności, po każdym opisie następuje pojedynczy pusty wiersz. W dalszej
części, zamiast „opis planszy”, będziemy pisać krótko „plansza”.<br/><br/>

#### Przykład:<br/>

```
wsghkgsw
pppppppp
........
........
....P...
........
PPPP.PPP
WSGHKGSW
wsghkgsw
pp.ppppp
..p.....
........
....P...
........
PPPP.PPP
WSGHKGSW
wsghkgsw
pppppppp
........
........
....P...
........
PPPP.PPP
WSGHKGSW
wsghkgsw
pp.ppppp
..p.....
........
....P...
........
PPPP.PPP
WSGHKGSW
```
<br/>

Dwie podane wyżej przykładowe plansze odpowiadają następującym stanom gry:<br/>
![](https://i.imgur.com/QDpW7Wf.png)

<br/>

![](https://i.imgur.com/R1uNeAN.png)


Napisz <b>program(-y)</b>, który(-e) znajdzie(-dą) odpowiedzi do poniższych zadań.
Do Twojej dyspozycji jest plik <i>szachy_przyklad.txt</i>, który zawiera 9 plansz zapisanych
w podanym wyżej formacie. Odpowiedzi dla pliku <i>szachy_przyklad.txt</i> podano w treści
poszczególnych zadań. Pamiętaj, że Twój(-e) program(-y) musi(-szą) działać dla 125 plansz.

<br/><br/>

### <u>Zadanie 3</u>   (0-4pkt.)

Wieża szachuje króla przeciwnego gracza, jeśli znajduje się w tym samym wierszu lub w tej
samej kolumnie co król i pomiędzy nimi nie ma żadnej innej bierki. <br/>
Oblicz i podaj, na ilu planszach biała wieża szachuje czarnego króla oraz na ilu planszach
czarna wieża szachuje białego króla. <br/><br/>
Odpowiedź dla pliku <i>szachy_przyklad.txt</i>:<br/>

```text
2 0
```
(2 razy biała wieża szachuje czarnego króla, 0 razy czarna wieża szachuje białego króla).

<br/>
<br/>

<Dropdown title="ODPOWIEDŹ">

```text
3 1
```

<p className={`dropdown_text`}>
    na 3 planszach biała wieża szachuje czarnego króla, natomiast na 1 planszy czarna wieża szachuje białego króla
</p>

</Dropdown>





<Dropdown title="PRZYKŁADOWE ROZWIĄZANIE - PYTHON">

```python
def get_boards() -> list[list[str]]:
    with open(r"szachy.txt") as text_file:
        boards_strs = text_file.read().strip("\n ").split("\n\n")

    boards = []

    for board_string in boards_strs:

        board_lines = [list(line) for line in board_string.split("\n")]

        boards.append(board_lines)

    return boards


def rotate_matrix(matrix: list[list]) -> list[list]:

    new_matrix = []

    for column_index in range(len(matrix[0])):
        new_matrix.append([])
        for row_index in range(len(matrix)):
            new_matrix[-1].append(matrix[row_index][column_index])

    return new_matrix


def join_rows_and_remove_dots(rows: list[list]) -> list["str"]:
    return ["".join(row).replace(".", "") for row in rows]


def check_board_for_mate(board_oryginal: list[list[str]], mate_type: str = "") -> bool:
    for board in [board_oryginal, rotate_matrix(board_oryginal)]:
        board = join_rows_and_remove_dots(board)

        for row in board:
            if mate_type in row or mate_type[::-1] in row:
                return True

    return False


def main():
    boards = get_boards()

    white_wins = 0
    black_wins = 0

    for board in boards:

        black_wins += 1 if check_board_for_mate(board, "wK") else 0
        white_wins += 1 if check_board_for_mate(board, "Wk") else 0

    print(white_wins, black_wins)


if __name__ == "__main__":
    main()

```
</Dropdown>
